<mat-divider class="line"></mat-divider>
<span class="text secondary-text">{{ text | translate | titlecase }}</span>
<mat-divider class="line"></mat-divider>